import {createUseStyles} from "react-jss";
import HeaderBubblesBg from "/src/images/common/header/header-bubbles.svg";
import HeaderBubblesBgMd from "/src/images/common/header/header-bubbles-md.svg";
import HeaderBubblesBg1 from "/src/images/common/header/header-bubbles-1.svg";
import HeaderBubblesBgMd1 from "/src/images/common/header/header-bubbles-1-md.svg";
import HeaderBubblesBgSm1 from "/src/images/common/header/header-bubbles-1-sm.svg";
import HeaderBubblesBg2 from "/src/images/common/header/header-bubbles-2.svg";
import HeaderBubblesBgMd2 from "/src/images/common/header/header-bubbles-2-md.svg";
import HeaderLightBg from "/src/images/common/header/header-light.svg";
import HeaderLightBgMd from "/src/images/common/header/header-light-md.svg";
import HeaderLightBgSm from "/src/images/common/header/header-light-sm.svg";

export const useStyles = createUseStyles({
    headerContainer: {
        paddingTop: 98,
        paddingBottom: 120,
        "@media (max-width: 1200px)": {
            paddingTop: 160,
            paddingBottom: 248,
            display: "flex",
            flexDirection: "column"
        },
        "@media (max-width: 600px)": {
            paddingTop: 48,
            paddingBottom: 80
        }
    },
    withBanner: {
        paddingTop: 56,
        "@media (max-width: 1200px)": {
            paddingBottom: 56
        },
        "@media (max-width: 600px)": {
            paddingBottom: 40
        }
    },
    withBubbles: {
        "&:after": {
            content: "''",
            width: "100%",
            height: 507,
            display: "block",
            background: `url(${HeaderBubblesBg}) no-repeat`,
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            position: "absolute",
            zIndex: 1,
            left: 0,
            bottom: 70,
            "@media (max-width: 1200px)": {
                height: 620,
                width: "calc(100% + 32px)",
                background: `url(${HeaderBubblesBgMd}) no-repeat`,
                backgroundPosition: "center",
                bottom: 28
            },
            "@media (max-width: 600px)": {
                display: "none"
            }
        }
    },
    bubblesType1: {
        "&:after": {
            content: "''",
            width: "100%",
            height: 338,
            display: "block",
            background: `url(${HeaderBubblesBg1}) no-repeat`,
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            position: "absolute",
            zIndex: 1,
            left: 0,
            bottom: -74,
            "@media (max-width: 1200px)": {
                background: `url(${HeaderBubblesBgMd1}) no-repeat`,
                backgroundPosition: "center",
                bottom: 234,
                height: 350,
                backgroundSize: "100% 100%"
            },
            "@media (max-width: 600px)": {
                background: `url(${HeaderBubblesBgSm1}) no-repeat`,
                backgroundPosition: "center",
                bottom: 95,
                height: 277,
                backgroundSize: "100% 100%"
            }
        }
    },
    bubblesType2: {
        "&:after": {
            content: "''",
            width: "100%",
            height: 442,
            display: "block",
            background: `url(${HeaderBubblesBg2}) no-repeat`,
            backgroundPosition: "center",
            position: "absolute",
            zIndex: 1,
            left: 0,
            bottom: 80,
            "@media (max-width: 1200px)": {
                background: `url(${HeaderBubblesBgMd2}) no-repeat`,
                backgroundPosition: "center",
                bottom: 200,
                height: 680
            },
            "@media (max-width: 600px)": {
                display: "none"
            }
        }
    },
    withLight: {
        "&:before": {
            content: "''",
            width: 1228,
            height: 410,
            background: `url(${HeaderLightBg}) no-repeat`,
            display: "block",
            position: "absolute",
            top: 0,
            right: 0,
            mixBlendMode: "screen",
            opacity: 0.7,
            zIndex: 1,
            "@media (max-width: 1200px)": {
                width: 552,
                height: 554,
                background: `url(${HeaderLightBgMd}) no-repeat`,
            },
            "@media (max-width: 600px)": {
                width: 272,
                height: 468,
                background: `url(${HeaderLightBgSm}) no-repeat`,
            }
        }
    },
    withAdaptiveImg: {
        paddingTop: 158,
        paddingBottom: 48,
        "@media (max-width: 1200px)": {
            paddingTop: 80,
            paddingBottom: 32
        },
        "@media (max-width: 600px)": {
            paddingTop: 48
        }
    },
    promoBannerContainer: {
        "@media (max-width: 1200px)": {
            order: 1,
            marginTop: 56
        }
    },
    planBannerContainer: {
        position: "relative",
        zIndex: 2
    },
    headerTop: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        zIndex: 2,
        "@media (max-width: 1200px)": {
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "left",
            maxWidth: "100%",
            marginLeft: "auto",
            marginRight: "auto",
        },
    },
    headerTopFlexStart: {
        alignItems: "flex-start"
    },
    headerTitle: {
        color: "#FFFFFF",
        whiteSpace: "pre-line",
        "@media (max-width: 1200px)": {
            whiteSpace: "unset",
            "& br": {
                display: "none"
            }
        }
    },
    headerSubtitle: {},
    headerDescription: {
        marginTop: 24,
        color: "#FFFFFF",
        whiteSpace: "pre-line",
        "& a": {
            color: "#fff",
            textDecoration: "underline"
        },
        "@media (max-width: 1200px)": {
            whiteSpace: "unset",
            "& br": {
                display: "none"
            }
        },
        "@media (max-width: 600px)": {
            marginTop: 16,
            whiteSpace: "unset"
        }
    },
    blackStyle: {
        color: "#2D2442"
    },
    headerButtonsContainer: {
        display: "flex",
        alignItems: "center",
        marginTop: 40,
        "@media (max-width: 1200px)": {
            justifyContent: "flex-start"
        },
        "@media (max-width: 600px)": {
            flexDirection: "column"
        },
        "& a, button": {
            minWidth: 220,
            "@media (max-width: 1200px)": {
                minWidth: 248,
                width: "50%"
            },
            "@media (max-width: 600px)": {
                width: "100%"
            },
            "& + a, button": {
                marginLeft: 24,
                "@media (max-width: 1200px)": {
                    marginLeft: 24
                },
                "@media (max-width: 600px)": {
                    marginLeft: 0,
                    marginTop: 8
                }
            }
        }
    },
    headerSecondaryBtn: {
        "&:hover, &:focus": {
            backgroundColor: "#97DE6B !important",
            borderColor: "#97DE6B !important"
        }
    },
    headerImgContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 0,
        // minWidth: 600,
        // minHeight: 600,
        "@media (max-width: 1200px)": {
            minWidth: "unset",
            minHeight: "unset",
            width: "100%",
            marginTop: 64,
            marginLeft: "auto",
            marginRight: "auto",
            display: "none",
            textAlign: "center"
        },
        "@media (max-width: 600px)": {
            marginTop: 48
        }
    },
    headerImgVisible: {
        "@media (max-width: 1200px)": {
            display: "block"
        }
    },
    headerImg: {
        "@media (max-width: 600px)": {
            width: "100%",
            maxHeight: "unset !important",
            height: "auto"
        }
    },
    headerAnimation: {
        "@media (max-width: 1200px)": {
            display: "none"
        }
    },
    headerCarousel: {
        width: "100%",
        marginTop: 120,
        position: "relative",
        zIndex: 1,
        "@media (max-width: 1200px)": {
            marginTop: 80
        },
        "@media (max-width: 600px)": {
            marginTop: 48
        }
    },
    headerCarouselWhiteStyle: {
        "& .h2": {
            color: "#FFFFFF"
        }
    }
});
